import { GlKeysetPagination } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { isBoolean } from 'lodash-es';
import { historyPushState, buildUrlWithCurrentLocation } from '~/lib/utils/common_utils';
import { glListenersMixin } from '~/lib/utils/vue3compat/gl_listeners_mixin';
export default {
    name: 'ReleasesPagination',
    components: {
        GlKeysetPagination
    },
    mixins: [
        glListenersMixin
    ],
    props: {
        pageInfo: {
            type: Object,
            required: true,
            validator: (info)=>isBoolean(info.hasPreviousPage) && isBoolean(info.hasNextPage)
        }
    },
    methods: {
        onPrev (before) {
            historyPushState(buildUrlWithCurrentLocation(`?before=${before}`));
        },
        onNext (after) {
            historyPushState(buildUrlWithCurrentLocation(`?after=${after}`));
        }
    }
};
